import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'
import mean from 'lodash/mean'
import without from 'lodash/without'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'

interface Props {
  userId: number
  xAxis: number[]
  yAxis: number[]
}

const Body = ({ userId, xAxis, yAxis }: Props) => {
  const user: User | undefined = users.get(userId)
  const xValue = mean(without(xAxis, null))
  const yValue = mean(without(yAxis, null))
  const xNumber = xValue % 1 === 0 ? xValue : xValue.toFixed(2)
  const yNumber = yValue % 1 === 0 ? yValue : yValue.toFixed(2)
  const employeeName = (user && user.fullName()) || '-'
  const noEnoughDataPoints = i18n.t('competencies_v2.ninebox.form.missing_values')

  return (
    <Table.Row>
      <Table.Cell colSpan={4}>
        <Box flexDirection="row" alignItems="center">
          <Text.Normal weight="medium">{employeeName}</Text.Normal>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box flexDirection="row" alignItems="center">
          {isNaN(xValue) && <InformationTooltip information={noEnoughDataPoints} />}
          {!isNaN(xValue) && <Text.Normal weight="medium">{xNumber}</Text.Normal>}
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={2}>
        <Box flexDirection="row" alignItems="center">
          {isNaN(yValue) && <InformationTooltip information={noEnoughDataPoints} />}
          {!isNaN(yValue) && <Text.Normal weight="medium">{yNumber}</Text.Normal>}
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}

export default observer(Body)
